export default {
  methods: {
    toggleSearchBanner() {
      const bannerClass = document.getElementById('search-banner').classList
      const searchInput = document.getElementsByClassName('search-banner__input')[0]

      if (bannerClass.contains("search-banner--banner-visible")) {
        bannerClass.remove("search-banner--banner-visible")
      }
      else {
        bannerClass.add("search-banner--banner-visible")
        searchInput.focus()
      }
    }
  }
}
